import { Icon, Spin } from "antd";
import React, { useEffect, useState } from "react";

//  add fallbackSrc prop to LazyImage
export const LazyImage = (props) => {
  const [src, setSrc] = useState(props.src);
  const [retryCount, setRetryCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [usingFallback, setUsingFallback] = useState(false);

  useEffect(() => {
    setLoading(true);
    setError(false);
    const targetSrc = usingFallback ? props.fallbackSrc : props.src;

    const interval = setInterval(() => {
      const img = new Image();
      img.onload = () => {
        setSrc(targetSrc);
        setLoading(false);
        clearInterval(interval);
      };
      img.onerror = () => {
        if (retryCount >= 10) {
          if (!usingFallback && props.fallbackSrc) {
            setUsingFallback(true);
            setRetryCount(0);
            clearInterval(interval);
          } else {
            setError(true);
            setLoading(false);
            clearInterval(interval);
          }
        } else {
          setRetryCount(retryCount + 1);
        }
      };
      img.src = targetSrc;
    }, 300);

    return () => clearInterval(interval);
  }, [props.src, props.fallbackSrc, retryCount, usingFallback]);

  if (loading) {
    return (
      <Spin
        indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
        size="large"
      />
    );
  }

  if (error) {
    return (
      <div style={{ marginTop: "10%" }}>
        <svg
          t="1731639823425"
          className="icon"
          viewBox="0 0 1152 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="4477"
          width="225"
          height="200"
        >
          <path
            d="M1041.216 1019.776H110.08c-60.864 0-110.08-49.152-110.08-110.208V114.304C0 53.44 49.088 4.032 109.888 4.032h278.4c20.224 0 17.792 16.448 17.792 36.736 0 2.944-1.024 4.672-1.664 6.784 1.6 6.976-5.056 14.208-7.808 21.312L323.968 232.384l185.984 168a36.736 36.736 0 0 1 0.64 53.824L368.448 589.44l184.64 257.856-58.176-212.224c-3.328-11.52-9.28-25.728-1.728-35.008l157.888-189.824-141.696-141.696a36.672 36.672 0 0 1-1.152-50.624L650.688 17.152a36.16 36.16 0 0 1 27.52-13.12h362.752a110.08 110.08 0 0 1 110.336 110.272v795.264c0 60.8-49.472 110.208-110.08 110.208z m55.552-922.624a36.736 36.736 0 0 0-36.928-36.8h-380.672c-1.216 1.92-1.92 4.032-3.52 5.76l-125.632 175.36 140.352 140.352c13.376 13.312 14.4 34.56 2.496 49.152l-152.96 187.008 61.248 238.464c9.856 34.56-30.784 54.4-58.624 31.552L320.64 619.776a36.736 36.736 0 0 1-1.984-54.976l143.616-136.512-175.36-158.464a36.672 36.672 0 0 1-9.6-40.576L343.36 60.288H90.752a36.608 36.608 0 0 0-36.48 36.864V929.28c0 20.48 16.32 36.8 36.672 36.8h969.152c20.032 0 36.672-16.64 36.672-36.8V97.152z m-245.632 347.328a111.104 111.104 0 1 1 0-222.208 111.104 111.104 0 0 1 0 222.208z m-2.368-164.672a55.04 55.04 0 1 0 0 110.08 55.04 55.04 0 0 0 0-110.08z"
            fill="#555555"
            p-id="4478"
          ></path>
        </svg>
      </div>
    );
  }

  return <img {...props} src={src} alt={src} />;
};

export const FullScreenImage = (props) => {
  const { padding = 24, ...rest } = props;
  return (
    <LazyImage
      {...rest}
      style={{
        maxHeight: `calc(100vh - ${padding * 2}px)`,
        maxWidth: `calc(100vw - ${padding * 2}px)`,
        objectFit: "contain",
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/lazyImage/lazy-image.js